module.exports = __webpack_public_path__ + "img/30.fdc2935a.png";